/**
 * Permission Store - Tracks user consent for recording and authentication
 */

import { create } from 'zustand';

const STORAGE_KEY = 'refinevoice_permission_granted';

interface PermissionStore {
  hasGrantedPermission: boolean;

  /**
   * Grant permission and persist to localStorage
   */
  grantPermission: () => void;

  /**
   * Revoke permission
   */
  revokePermission: () => void;

  /**
   * Check if permission has been granted
   */
  checkPermission: () => boolean;
}

// Load initial permission state from localStorage
function loadInitialPermission(): boolean {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'true';
  } catch {
    return false;
  }
}

export const usePermissionStore = create<PermissionStore>((set, get) => ({
  hasGrantedPermission: loadInitialPermission(),

  grantPermission: () => {
    set({ hasGrantedPermission: true });
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
      console.error('Failed to save permission to localStorage:', error);
    }
  },

  revokePermission: () => {
    set({ hasGrantedPermission: false });
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Failed to remove permission from localStorage:', error);
    }
  },

  checkPermission: () => {
    return get().hasGrantedPermission;
  },
}));
